import React, { Component } from 'react'
import { from } from 'rxjs/observable/from'
import { delay } from './functions'

class ComponentUnmounter extends Component {
    constructor(props) {
        super(props)
        this.state = { visible: false }
    }

    updateState(props) {
        const timeOut = props.timeOut || 1000

        this.update && this.update.unsubscribe()

        if (props.visible && !this.state.visible) {
            this.setState({ visible: true })
        } else if (!props.visible && this.state.visible) {
            this.update = from(delay(timeOut)).subscribe(() => {
                const { onUnMounted } = this.props

                this.setState(
                    {
                        visible: false,
                    },
                    _ => onUnMounted && onUnMounted()
                )
            })
        }
    }

    componentWillMount() {
        this.updateState(this.props)
    }

    componentWillReceiveProps(props) {
        this.updateState(props)
    }

    componentWillUnmount() {
        this.update && this.update.unsubscribe()
    }

    render() {
        let children = typeof this.props.children == 'function' ? this.props.children() : this.props.children

        return this.state.visible ? children : null
    }
}

export default ComponentUnmounter
